import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { Router } from '@angular/router';
import { ErrorModalLabel_EN } from '../models/labels/errorModalLabel_EN';
import { BorrowerRenderingService } from '../services/borrower/borrower-rendering.service';
import { BorrowerDTO } from '../models/borrower/borrower-dto';
import { IncomeDTO } from '../models/borrower/income-dto';
import { LoanStep2 } from '../models/borrower/loan-step2';
import { LoanStep1 } from '../models/borrower/loan-step1';
import { Parameter } from '../models/borrower/loanFormParameter';
import { QuoteRenderingService } from '../services/search/quote-rendering.service';
import { NewQuote } from '../models/search/new-quote';
import { QuotationEntityIdDto } from '../models/search/quotation-entity-id-dto';
import { SearchQuote } from '../models/search/search-quote';
import { LoanStep3 } from '../models/borrower/loan-step3';
import { LoanStep4 } from '../models/borrower/loan-step4';
import { ApiService } from '../services/api/api.service';
import { LoginRenderingService } from '../services/login/login-rendering.service';

@Component({
  selector: 'app-home-modal',
  templateUrl: './home-modal.component.html',
  styleUrls: ['./home-modal.component.scss']
})
export class HomeModalComponent implements OnInit {

  label: any;
  logoname: string;

  constructor(private loginRenderingService: LoginRenderingService, public dialogRef: MatDialogRef<HomeModalComponent>, private apiService: ApiService,
    private router: Router, private borrowerService: BorrowerRenderingService, private quoteService: QuoteRenderingService) { }

  ngOnInit() {
    this.label = new ErrorModalLabel_EN();
  }

  home() {

    this.borrowerService.primaryBorrower = new BorrowerDTO();
    this.borrowerService.incomeBorrower = new IncomeDTO();
    this.borrowerService.incomeCoBorrower = new IncomeDTO();
    this.borrowerService.loanStep1 = new LoanStep1();
    this.borrowerService.loanStep2 = new LoanStep2();
    this.borrowerService.loanStep3 = new LoanStep3();
    this.borrowerService.loanStep4 = new LoanStep4();
    this.borrowerService.parameter = new Parameter();
    this.borrowerService.coApplicantBorrower = new BorrowerDTO();

    this.quoteService.newQuote = new NewQuote();
    this.quoteService.quotation = new QuotationEntityIdDto();
    this.quoteService.searchQuote = new SearchQuote();
    this.quoteService.checkModifyButton = false;

    const brand = JSON.parse(localStorage.getItem("currentUser"));
    window.localStorage.setItem('theme-name', brand.brands);
    this.apiService.setLocalStorage(brand);
    // this.apiService.setLogoName();
    localStorage.removeItem("logoImage");
    this.dialogRef.close();
    this.router.navigate(['/home']);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
